export const GET = "GET";
export const POST = "POST";
export const PATCH = "PATCH";
export const PUT = "PUT";
export const DELETE = "DELETE";


// WEBPACK FOOTER //
// ./src/constants/HTTPConstants.js